import { ReactElement } from 'react';

import { TherapeuticGroupStatus } from '@dreryk/egabinet-group-session-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Multiselect } from '@dreryk/react-components';

import {
   GroupSessionsFilterPanelFormBean,
   GroupSessionsFilterPanelSearchParam,
   GroupSessionsFilterPanelStorageKey,
} from '../../GroupSessionsFilterPanel.types';
import { translationKeys } from '../../../translations';

import {
   createStatusTriggerLabelExtractor,
   STATUSES,
   statusesCodec,
   statusesDeselectorsPropsMapper,
} from './StatusController.utils';
import { StyledReservationPreferenceMultiselect } from './StatusMultiselect.styled';

type ReservationPreferenceControllerProps = {
   registerController: BindingCreator<GroupSessionsFilterPanelFormBean, 'statuses'>;
};

export const StatusController = (props: ReservationPreferenceControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<GroupSessionsFilterPanelFormBean, 'statuses'>
         name={'statuses'}
         searchParam={GroupSessionsFilterPanelSearchParam.STATUS}
         storageKey={GroupSessionsFilterPanelStorageKey.STATUS}
         codec={statusesCodec}
         chipsLabel={translationKeys.status}
         getDeselectorsProps={statusesDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledReservationPreferenceMultiselect<TherapeuticGroupStatus>
               testId={'statuses'}
               triggerLabelExtractor={createStatusTriggerLabelExtractor(translate)}
               controller={props.registerController('statuses')}
               onHide={applyFilter}
               label={translationKeys.status}
               placeholder={translationKeys.chooseStatus}
               compact
            >
               <>
                  <Multiselect.SelectAll testId={'selectAllStatuses'} items={STATUSES} />
                  <Multiselect.List<TherapeuticGroupStatus> items={STATUSES}>
                     {(item) => (
                        <Multiselect.Item
                           item={item}
                           label={translationKeys.groupSessionsStatusMap[item]}
                           testId={item}
                        />
                     )}
                  </Multiselect.List>
               </>
            </StyledReservationPreferenceMultiselect>
         )}
      </FilterPanel.Controller>
   );
};
